import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Document, DocItems } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

@Component({
  selector: 'app-new-document-dlg-process-transaction',
  templateUrl: './new-document-dlg-process-transaction.component.html',
  styleUrls: ['./new-document-dlg-process-transaction.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessTransactionComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;

  /*
   * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
   */
  @Input() parentDocument: Document;

  /*
   * Therefore, to keep source object untouched (immutable ????)
   * we will expect alone/independent copy of DocItems as Input parameter
   * 
   */

  @Input() docItems: DocItems[];

  @Input() newDocument: Document;

  @Input() newDocuments: Document[];

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  command: number = 0;  /* Command to child components what to do
                         *
                         * 0 - nothing / prepare
                         * 1 - go
                         * 2 - clean
                         * 3 - reset to initial state
                         * 
                         */ 

  parentDocumentId: number;

  sourceDocItems: DocItems[];

  @Input() countEmptyDocItems: boolean = false;

  @Output() blocking: EventEmitter<boolean> = new EventEmitter();

  moveAction: number = 1;

  actions =
    [
      { name: 'На основе валютной цены', value: 1, disabled: false },
      { name: 'Удалить существующие позиции', value: 3, disabled: false },
      { name: 'Учитывать пустые строки', value: 10, disabled: false },
  ];

  selectedActions: any = [1];

  transactionResult: any[] = null;

  private currencyQuery: Subscription;

  @Output() onCreateNewDocuments = new EventEmitter<Document[]>();

  @Output() onGetTransactionResult = new EventEmitter<any[]>();

  public get eligibleForMove(): boolean { return (this.parentDocument && [2,3,5].includes( this.parentDocument.DOCTYPE)); }

  public get thereIsManufacturedItems(): boolean { return (((this.docItems || []).filter(di => (di.PRODKIND == 1))).length > 0); }

constructor(
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  setInitialValues(action: number) {
    console.log('*** NewDocumentDlgProcessTransactionComponent setInitialValues: action ' + action);

    this.command = 0;
  }

  processDocItems() {
    console.log('*** NewDocumentDlgProcessTransactionComponent in processDocItems');

    this.command = 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      // console.log('*** NewDocumentDlgProcessTransactionComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
            this.command = 0;
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.command = 0;
          }
          break;

        case 'parentDocument':
          if (this.parentDocument) {

            switch (this.parentDocument.DOCTYPE) {

              case 1: this.moveAction = this.thereIsManufacturedItems ? 2 : 3; break;

              case 2:
              case 3: this.moveAction = 4; break;
              case 5: this.moveAction = 4; break;

              case 4: this.moveAction = 1; break;
            }
            this.command = 0;
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessTransactionComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessTransactionComponent in ngOnInit');

    /*
     * TODO: Make subscription to newDocument currency rate, because it is quite complex task to wait the set the rate in the main thread
     * Potentially problematic due to different sources ??????
     */

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.setInitialValues(this.moveAction);
  }

  onDocTypeChanges(event) {
    console.log('*** NewDocumentDlgProcessTransactionComponent onDocTypeChanges ' + JSON.stringify(event));

    if (event.value.includes(1)) {
      console.log('*** NewDocumentDlgProcessTransactionComponent doCurrencyBased document ' + JSON.stringify(event.value));
      /*
       * TODO: Check whether currency of newDocument equal to those in parentDocument
       *       May be we need more sofisticated parameters checking
       */
    }
    if (event.value.includes(2)) {
      console.log('*** NewDocumentDlgProcessTransactionComponent copy U4etka info' + JSON.stringify(event.value));
    }
  }

  onClearRows(event) {
    console.log('*** NewDocumentDlgProcessTransactionComponent onClearRows ' + JSON.stringify(event));

    this.command = 2;
  }

  onRefreshRows(event) {
    console.log('*** NewDocumentDlgProcessTransactionComponent onRefreshRows ' + JSON.stringify(event));

    this.command = 3;
  }

  onMoveActionChange(event) {
    console.log('*** NewDocumentDlgProcessTransactionComponent onRefreshRows ' + JSON.stringify(event));

    switch (event.index) {
      case 0:
        this.moveAction = 1;

        break;

      case 1:
        this.moveAction = 2;
        break;

      case 3:
        this.moveAction = 3;
        break;

      case 2:
        this.moveAction = 4;
        break;

      case 4:
        this.moveAction = 5;
        break;
    }
    this.command = 0;
  }
  onStartProduction(event) {
    console.log('*** NewDocumentDlgProcessTransactionComponent onStartProduction ' + JSON.stringify(event));

    this.processDocItems();
  }

  // Catch new documents from child component
  onCreateNewDocumentsEvent(event) {
    this.onCreateNewDocuments.emit(event);
  }

  // Catch transaction result from child component

  getTransactionResult(event: any[]) {
    environment.production || console.log('*** NewDocumentDlgProcessTransactionComponent onGetTransactionResult ' + JSON.stringify(event));

    this.transactionResult = event;
    this.onGetTransactionResult.emit(event);
  }
}
